import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
const founders = [{
  name: 'Rob Frid',
  title: 'Founder & President of Development',
  slug: 'rob-frid',
  photo: 'https://cdn.magicpatterns.com/uploads/tNKtzo6iMqSY4iPn9J184Z/5752.png',
  actionPhoto: 'https://cdn.magicpatterns.com/uploads/drnjLYkADkGvq7ohwJ1YTF/5754.png',
  bio: 'A Canadian former minor-league hockey player turned hockey skills instructor, development advisor, and player placement director. Drafted by the London Knights of the OHL, Rob spent nearly nine seasons in professional hockey across the ECHL, CHL, WCHL, UHL, and U Sports.',
  quote: "We don't just build players; we build resilient individuals ready for any challenge the game throws at them."
}, {
  name: 'Scott Blair',
  title: 'VP of Operations',
  slug: 'scott-blair',
  photo: 'https://cdn.magicpatterns.com/uploads/f6VUSkdgXoyVX3aUmVpiam/5753.png',
  actionPhoto: 'https://cdn.magicpatterns.com/uploads/vcv3A1bUgZrtybtvAE23Cw/5746.png',
  bio: 'Scott Blair was a 3 time USA Hockey National Champion and OHL Champion. He played professional hockey in the Chicago Blackhawks system and also played some years in Europe. He currently plays overseas and works on and off ice with players in a developmental role during the offseason in Tampa, FL.',
  quote: "Success isn't just about talent. It's about having the right plan, the right network, and the resilience to execute."
}];
export const FoundersSection = () => {
  return <section id="team" className="py-24 bg-navy-800 relative" data-id="element-81">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <div className="text-center mb-16" data-id="element-83">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="text-4xl md:text-5xl font-bold text-white mb-4 uppercase tracking-tight" data-id="element-84">
            The Team Behind <span className="text-ice-500" data-id="element-85">UHD</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-86">
            Mentorship from former professional hockey players with an extensive
            amount of experience and a wide network of contacts.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-87">
          {founders.map((founder, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-navy-900 border border-navy-700 p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-88">
              {/* Decorative corner */}
              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-navy-700 m-4 opacity-50" data-id="element-89"></div>

              <div className="flex flex-col sm:flex-row gap-6 items-start mb-8" data-id="element-90">
                <div className="w-32 h-36 shrink-0 rounded-sm overflow-hidden border-2 border-gold-500 shadow-lg shadow-gold-500/10 bg-navy-700" data-id="element-91">
                  <img src={founder.photo} alt={founder.name} className="w-full h-full object-cover object-center" data-id="element-92" />
                </div>
                <div data-id="element-93">
                  <h3 className="text-2xl font-bold text-white mb-1" data-id="element-94">
                    {founder.name}
                  </h3>
                  <p className="text-ice-500 font-semibold text-sm uppercase tracking-wider mb-4" data-id="element-95">
                    {founder.title}
                  </p>
                  <p className="text-slate-300 leading-relaxed mb-6" data-id="element-96">
                    {founder.bio}
                  </p>
                  <Link to={`/${founder.slug}`} className="inline-flex items-center text-gold-500 hover:text-gold-400 font-bold transition-colors group" data-id="element-97">
                    Read Full Bio
                    <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-98" />
                  </Link>
                </div>
              </div>

              <div className="bg-navy-800/50 p-6 rounded-sm border-l-4 border-ice-500 italic text-slate-400" data-id="element-99">
                "{founder.quote}"
              </div>

              {/* Action Photo */}
              <div className="mt-6 rounded-sm overflow-hidden border border-navy-700 h-56 bg-navy-700" data-id="element-100">
                <img src={founder.actionPhoto} alt={`${founder.name} in action`} className="w-full h-full object-cover object-center" data-id="element-101" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};